import React from 'react';
import './CadSection.css';

const CadSection = () => {
  return (
    <div className="cad-section-container">
      <div className="cad-box">
        {/* ✅ Use image from public/assets */}
        <div className="cad-icon-wrapper">
          <img src="/assets/Admin-Module.png" alt="Helmet Icon" className="cad-icon-img" />
        </div>

        <h2>HEXAGON PPM SMART 3D/AVEVA EVERYTHING3D Administration</h2>

        <div className="cad-list-section">
          <h3>- CAD Admin Installations</h3>
          <ul>
            <li>Installing and configuring AVEVA E3D/ HEXAGON SP3D Software</li>
          </ul>
        </div>

        <div className="cad-list-section">
          <h3>- CAD Procedure</h3>
          <ul>
            <li>HEXAGON PPM SMART 3D /AVEVA EVERYTHING3D Admin. Procedure</li>
            <li>HEXAGON PPM SMART 3D /AVEVA EVERYTHING3D Modelling Procedure</li>
            <li>HEXAGON PPM SMART 3D /AVEVA EVERYTHING3D/Naviswork Clash Procedure</li>
            <li>Review Procedure</li>
          </ul>
        </div>

        <div className="cad-list-section">
          <h3>- Setup Projects</h3>
          <ul>
            <li>Setup HEXAGON PPM SMART 3D /AVEVA EVERYTHING3D Global and Stand Alone Projects</li>
            <li>Excel bulk load sheets for Smart 3D</li>
            <li>Configure Users, Teams, Database and MDB</li>
            <li>Configure the files .batch of Aveva</li>
            <li>Master the management and operations on databases</li>
            <li>Identifying a specific session (STAMP)</li>
            <li>Return to a previous session (BACKTRACK)</li>
            <li>Deleting the history of a project (MERGE)</li>
            <li>Checking the status of a database (DICE)</li>
            <li>Reconfiguring a database (RECON)</li>
            <li>Creating color rules in the Design module and inter-DBs macro management</li>
          </ul>
        </div>

        <div className="cad-list-section">
          <h3>- Subcontractors</h3>
          <ul>
            <li>Support the Client to definition and maintenance of specifications, such as 3D modeling specification and working procedures, to be used by Company Subcontractors working on projects</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default CadSection;